import { HTTP } from './helpers/http.js'

export default {
  getById(organizationId, revId) {
    const url = `/api/v1/organizations/${organizationId}/quick-actions/${revId}`
    return HTTP.get(url)
  },

  create(organizationId, data) {
    const url = `/api/v1/organizations/${organizationId}/quick-actions`
    return HTTP.post(url, data)
  },

  update(organizationId, revId, data) {
    const url = `/api/v1/organizations/${organizationId}/quick-actions/${revId}`
    return HTTP.patch(url, data)
  },

  delete(organizationId, revId) {
    const url = `/api/v1/organizations/${organizationId}/quick-actions/${revId}`
    return HTTP.delete(url)
  },

  share(organizationId, payload) {
    const url = `/api/v1/organizations/${organizationId}/shares`
    const { sharedBy, sharedTo, message, sharedObjectId } = payload

    return HTTP.post(url, {
      organizationId,
      sharedBy,
      sharedTo,
      message,
      sharedObjectId,
      sharedObjectType: 'QuickAction',
    })
  },

  addValidation({
    organizationId,
    revId,
    validationType,
    isValidated,
    validatedReview,
  }) {
    const url = `/api/v1/organizations/${organizationId}/quick-actions/${revId}/validations`
    return HTTP.post(url, {
      type: validationType,
      isValidated,
      validatedReview,
    })
  },

  editValidation({
    organizationId,
    revId,
    validationId,
    validationType,
    isValidated = true,
    validatedReview,
  }) {
    const url = `/api/v1/organizations/${organizationId}/quick-actions/${revId}/validations/${validationId}`
    return HTTP.put(url, {
      type: validationType,
      isValidated,
      validatedReview,
    })
  },

  removeValidation({ organizationId, revId, validationId }) {
    const url = `/api/v1/organizations/${organizationId}/quick-actions/${revId}/validations/${validationId}`
    return HTTP.delete(url)
  },

  addHighlight({ organizationId, revId }) {
    return HTTP.post(
      `/api/v1/organizations/${organizationId}/quick-actions/${revId}/highlights`
    )
  },

  removeHighlight({ organizationId, revId }) {
    return HTTP.delete(
      `/api/v1/organizations/${organizationId}/quick-actions/${revId}/highlights`
    )
  },

  savePartialValidation(organizationId, revId, data) {
    const url = `/api/v1/organizations/${organizationId}/quick-actions/${revId}/validation-impacts`
    return HTTP.patch(url, data)
  },

  addImplementValidation({ organizationId, revId }) {
    return HTTP.post(
      `/api/v1/organizations/${organizationId}/quick-actions/${revId}/implementation-validations`
    )
  },

  removeImplementationValidation({ organizationId, revId, validationId }) {
    return HTTP.delete(
      `/api/v1/organizations/${organizationId}/quick-actions/${revId}/implementation-validations/${validationId}`
    )
  },

  addImpactValidation({ organizationId, revId }) {
    return HTTP.post(
      `/api/v1/organizations/${organizationId}/quick-actions/${revId}/impact-validations`
    )
  },

  removeImpactValidation({ organizationId, revId, validationId }) {
    return HTTP.delete(
      `/api/v1/organizations/${organizationId}/quick-actions/${revId}/impact-validations/${validationId}`
    )
  },
}
